/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDriverSettlementProfile.ts       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/driver-settlement/driver-settlement-profile";

export class AutogenModelDriverSettlementProfile<RowType extends ModelRow> extends Endpoint<RowType, RowDriverSettlementProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDriverSettlementProfile extends ModelRow<RowDriverSettlementProfileFields> {
	constructor(values?: Partial<RowDriverSettlementProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDriverSettlementProfileFields {
	bo_reason_code: string;
	bo_reason_code_exclude: string;
	bonus_code: string;
    bonus_tax_method: string;
	company_id: string;
	currency_type: string;
	cutoff_date: string;
	departments: string;
	departments_exclude: string;
	descr: string;
	frozen_payables: string;
	id: string;
	is_contract_transfer: boolean;
	only_payees_activity: string;
	override_frequency: string;
	pay_frequency: string;
	pay_rate_method: string;
	payee_ids: string;
	payee_ids_exclude: string;
	payee_status: string;
	payee_type: string;
	payment_method: string;
	profile_color: string;
	start_date: string;
	transaction_num: string;
}

